export default __webpack_public_path__ + "static/media/img-o-n-4-leaderboard-mobile.a926accb.jpg";